import {Component, OnInit} from '@angular/core';
import {RouterStateSpinnerService} from './router-state-spinner.service';

@Component({
    selector: 'app-router-state-spinner',
    templateUrl: './router-state-spinner.component.html',
    styleUrls: ['./router-state-spinner.component.scss'],
    standalone: false
})
export class RouterStateSpinnerComponent implements OnInit {

  public state;

  constructor(private spinnerService: RouterStateSpinnerService) {
  }

  ngOnInit() {
    this.state = this.spinnerService.state;
    this.state.update = () => {
      /*$state.reload()*/
    };
  }

}
